import React from 'react';
import { companyInfo } from '../../data/mock';

const WhatsAppButton = () => {
  const whatsappLink = `https://wa.me/55${companyInfo.whatsapp}?text=Olá! Gostaria de um orçamento.`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-16 h-16 bg-[#25D366] rounded-full shadow-lg hover:bg-[#20bd5a] transition-all duration-300 hover:scale-110 whatsapp-pulse"
      aria-label="Chamar no WhatsApp"
    >
      <svg 
        viewBox="0 0 32 32" 
        className="w-8 h-8 fill-white"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M16.002 0C7.165 0 0.002 7.163 0.002 16c0 2.822.735 5.562 2.133 7.986L.013 32l8.274-2.17A15.92 15.92 0 0 0 16.002 32C24.838 32 32 24.837 32 16S24.838 0 16.002 0Zm0 29.09a13.06 13.06 0 0 1-6.662-1.82l-.478-.284-4.954 1.299 1.322-4.832-.312-.497A13.05 13.05 0 0 1 2.913 16c0-7.224 5.877-13.09 13.089-13.09 7.223 0 13.089 5.866 13.089 13.09 0 7.223-5.866 13.09-13.089 13.09Zm7.175-9.807c-.394-.197-2.329-1.149-2.69-1.28-.36-.131-.623-.197-.885.197-.263.394-1.016 1.28-1.247 1.543-.23.262-.46.295-.854.098-.394-.197-1.663-.613-3.168-1.955-1.17-1.044-1.961-2.333-2.191-2.727-.23-.394-.025-.607.173-.803.177-.176.394-.46.59-.689.198-.23.264-.394.395-.656.131-.263.066-.493-.033-.69-.098-.197-.885-2.133-1.213-2.92-.32-.766-.644-.663-.885-.675-.23-.01-.493-.013-.755-.013-.263 0-.689.099-1.05.493-.36.394-1.378 1.346-1.378 3.282 0 1.936 1.411 3.806 1.607 4.07.197.262 2.776 4.238 6.725 5.942.94.406 1.673.648 2.244.83.943.3 1.801.257 2.48.156.756-.113 2.328-.952 2.657-1.871.329-.92.329-1.707.23-1.871-.098-.164-.36-.263-.754-.46Z"/>
      </svg>
    </a>
  );
};

export default WhatsAppButton;
